import { Box, TextField, Typography } from "@mui/material";
import DialogSelectItems from "./DialogSelectItems";
import { useState } from "react";
import {
  ContaContabil,
  ContaContabilResumida,
} from "../../../types/api/geral/pesquisar-plano-contas";

export default function SelectPlanoContas({
  inputLabel,
  value,
  onChangeValue,
  extraParams = {},
  required = false,
  error = false,
  errorMessage = "Campo obrigatório",
  hasCentroCusto = true,
}: SelectPlanoContasProps) {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const CustomInputComponent = ({ value, onClick }: CustomInputComponent) => {
    const commonStyles = {
      display: "flex",
      width: "100%",
      padding: "8px 12px",
      height: "56px",
    };

    if (!value)
      return (
        <TextField
          {...{ onClick }}
          variant="outlined"
          fullWidth
          slotProps={{
            input: { readOnly: true }
          }}
        />
      );

    return (
      <Box
        {...{ onClick }}
        sx={{
          ...commonStyles,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant={Boolean(value.centro_custo) ? "subtitle2" : "body1"}
        >
          {`${value.codigo_contabil ?? ""}${value.nome ? ` - ${value.nome}` : ""
            }`}
        </Typography>
        {Boolean(value.centro_custo) && hasCentroCusto && (
          <Typography variant="caption" color="gray" mt={-0.3}>
            Centro de custo: {value.centro_custo?.id} -{" "}
            {value.centro_custo?.nome}
          </Typography>
        )}
      </Box>
    );
  };

  return (
    <>
      <TextField
        {...{ required, error }}
        fullWidth
        label={inputLabel}
        onClick={() => setOpenModal(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            setOpenModal(true);
          }
        }}
        slotProps={{
          inputLabel: { shrink: Boolean(value) },
          input: {
            readOnly: true,
            inputComponent: () => (
              <CustomInputComponent
                {...{ value }}
                onClick={() => setOpenModal(true)}
              />
            )
          }
        }}
        helperText={error ? errorMessage : ""}
      />

      {openModal && (
        <DialogSelectItems
          {...{ extraParams }}
          open={openModal}
          defValue={value}
          handleClose={() => setOpenModal(false)}
          title={inputLabel.toLowerCase()}
          onSubmitValue={onChangeValue}
          hasCentroCusto={hasCentroCusto}
        />
      )}
    </>
  );
}

interface SelectPlanoContasProps {
  inputLabel: string;
  value: Value;
  onChangeValue: OnChangeValue;
  extraParams?: TExtraParams;
  required?: boolean;
  error?: boolean;
  errorMessage?: string;
  hasCentroCusto?: boolean;
}

interface CustomInputComponent {
  value: Value;
  onClick: () => void;
}

export type Value = ContaContabil | ContaContabilResumida | null;
export type OnChangeValue = (
  arg: ContaContabil | ContaContabilResumida
) => void;
export type TExtraParams = {
  sistema_xy?: string;
  tipo?: "Analítica" | "Sintética";
};
